// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as Flash_Edit_Utils$DvmAdminFrontendFr from "./Flash_Edit_Utils.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../context/user/User_Types_Utils.bs.js";

var validators_attributionVehicleDateEnd = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, param$1) {
      if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(param$1.selectedRole) === /* Spain */1) {
        return Flash_Edit_Utils$DvmAdminFrontendFr.validateDate(param.attributionVehicleDateStart, param.attributionVehicleDateEnd, "larger", false, false, undefined, undefined);
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_attributionVehicleDateStart = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, param$1) {
      if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(param$1.selectedRole) === /* Spain */1) {
        return Flash_Edit_Utils$DvmAdminFrontendFr.validateDate(param.attributionVehicleDateStart, param.attributionVehicleDateEnd, "smaller", false, false, undefined, undefined);
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_dealerWithAgents = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, param$1) {
      var orderGroup = param$1.orderGroup;
      if (orderGroup === /* RR */5 || orderGroup === /* RC */6) {
        return {
                TAG: /* Ok */0,
                _0: Belt_List.map(param.dealerWithAgents, (function (x) {
                        return x.value;
                      }))
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: /* [] */0
              };
      }
    })
};

var validators_dealerIds = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, param$1) {
      var orderGroup = param$1.orderGroup;
      if (orderGroup === /* RR */5 || orderGroup === /* RC */6) {
        return {
                TAG: /* Ok */0,
                _0: Belt_List.map(param.dealerIds, (function (x) {
                        return x.value;
                      }))
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: /* [] */0
              };
      }
    })
};

var validators_saleType = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, param$1) {
      return {
              TAG: /* Ok */0,
              _0: param.saleType
            };
    })
};

var validators_clientType = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, param$1) {
      return {
              TAG: /* Ok */0,
              _0: {
                hd: param.clientType,
                tl: /* [] */0
              }
            };
    })
};

var validators = {
  attributionVehicleDateEnd: validators_attributionVehicleDateEnd,
  attributionVehicleDateStart: validators_attributionVehicleDateStart,
  dealerWithAgents: validators_dealerWithAgents,
  dealerIds: validators_dealerIds,
  saleType: validators_saleType,
  clientType: validators_clientType
};

function initialFieldsStatuses(_input) {
  return {
          attributionVehicleDateEnd: /* Pristine */0,
          attributionVehicleDateStart: /* Pristine */0,
          dealerWithAgents: /* Pristine */0,
          dealerIds: /* Pristine */0,
          saleType: /* Pristine */0,
          clientType: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.attributionVehicleDateEnd;
  var match_0 = match ? match._0 : Curry._2(validators.attributionVehicleDateEnd.validate, input, metadata);
  var match$1 = fieldsStatuses.attributionVehicleDateStart;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.attributionVehicleDateStart.validate, input, metadata);
  var match$2 = fieldsStatuses.dealerWithAgents;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.dealerWithAgents.validate, input, metadata);
  var match$3 = fieldsStatuses.dealerIds;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.dealerIds.validate, input, metadata);
  var match$4 = fieldsStatuses.saleType;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.saleType.validate, input, metadata);
  var match$5 = fieldsStatuses.clientType;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.clientType.validate, input, metadata);
  var attributionVehicleDateEndResult = match_0;
  var attributionVehicleDateEndResult$1;
  if (attributionVehicleDateEndResult.TAG === /* Ok */0) {
    var attributionVehicleDateStartResult = match_0$1;
    if (attributionVehicleDateStartResult.TAG === /* Ok */0) {
      var dealerWithAgentsResult = match_0$2;
      if (dealerWithAgentsResult.TAG === /* Ok */0) {
        var dealerIdsResult = match_0$3;
        if (dealerIdsResult.TAG === /* Ok */0) {
          var saleTypeResult = match_0$4;
          if (saleTypeResult.TAG === /* Ok */0) {
            var clientTypeResult = match_0$5;
            if (clientTypeResult.TAG === /* Ok */0) {
              return {
                      TAG: /* Valid */0,
                      output: {
                        clientType: clientTypeResult._0,
                        saleType: saleTypeResult._0,
                        dealerIds: dealerIdsResult._0,
                        dealerWithAgents: dealerWithAgentsResult._0,
                        attributionVehicleDateStart: attributionVehicleDateStartResult._0,
                        attributionVehicleDateEnd: attributionVehicleDateEndResult._0
                      },
                      fieldsStatuses: {
                        attributionVehicleDateEnd: /* Dirty */{
                          _0: attributionVehicleDateEndResult,
                          _1: /* Shown */0
                        },
                        attributionVehicleDateStart: /* Dirty */{
                          _0: attributionVehicleDateStartResult,
                          _1: /* Shown */0
                        },
                        dealerWithAgents: /* Dirty */{
                          _0: dealerWithAgentsResult,
                          _1: /* Shown */0
                        },
                        dealerIds: /* Dirty */{
                          _0: dealerIdsResult,
                          _1: /* Shown */0
                        },
                        saleType: /* Dirty */{
                          _0: saleTypeResult,
                          _1: /* Shown */0
                        },
                        clientType: /* Dirty */{
                          _0: clientTypeResult,
                          _1: /* Shown */0
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
          } else {
            attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
          }
        } else {
          attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
        }
      } else {
        attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
      }
    } else {
      attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
    }
  } else {
    attributionVehicleDateEndResult$1 = attributionVehicleDateEndResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            attributionVehicleDateEnd: /* Dirty */{
              _0: attributionVehicleDateEndResult$1,
              _1: /* Shown */0
            },
            attributionVehicleDateStart: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            dealerWithAgents: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            dealerIds: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            saleType: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            clientType: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurAttributionVehicleDateEndField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.attributionVehicleDateEnd, validators_attributionVehicleDateEnd, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: status,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAttributionVehicleDateStartField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.attributionVehicleDateStart, validators_attributionVehicleDateStart, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: status,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDealerWithAgentsField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.dealerWithAgents, validators_dealerWithAgents, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: status,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDealerIdsField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.dealerIds, validators_dealerIds, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: status,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSaleTypeField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.saleType, validators_saleType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: status,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurClientTypeField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.clientType, validators_clientType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */6 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */6,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */7,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */9);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */8);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */7 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */8 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */9 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateAttributionVehicleDateEndField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$6 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput, metadata, nextFieldsStatuses.contents.attributionVehicleDateStart, validators_attributionVehicleDateStart, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                  attributionVehicleDateStart: status,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$6 !== undefined) {
                    nextFieldsStatuses.contents = result$6;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, nextFieldsStatuses.contents.attributionVehicleDateEnd, state.submissionStatus, validators_attributionVehicleDateEnd, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            attributionVehicleDateEnd: status,
                                            attributionVehicleDateStart: init.attributionVehicleDateStart,
                                            dealerWithAgents: init.dealerWithAgents,
                                            dealerIds: init.dealerIds,
                                            saleType: init.saleType,
                                            clientType: init.clientType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAttributionVehicleDateStartField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$7 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.attributionVehicleDateEnd, validators_attributionVehicleDateEnd, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  attributionVehicleDateEnd: status,
                                  attributionVehicleDateStart: init.attributionVehicleDateStart,
                                  dealerWithAgents: init.dealerWithAgents,
                                  dealerIds: init.dealerIds,
                                  saleType: init.saleType,
                                  clientType: init.clientType
                                };
                        }));
                  if (result$7 !== undefined) {
                    nextFieldsStatuses$1.contents = result$7;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.attributionVehicleDateStart, state.submissionStatus, validators_attributionVehicleDateStart, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                            attributionVehicleDateStart: status,
                                            dealerWithAgents: init.dealerWithAgents,
                                            dealerIds: init.dealerIds,
                                            saleType: init.saleType,
                                            clientType: init.clientType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDealerWithAgentsField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.dealerWithAgents, state.submissionStatus, validators_dealerWithAgents, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                            attributionVehicleDateStart: init.attributionVehicleDateStart,
                                            dealerWithAgents: status,
                                            dealerIds: init.dealerIds,
                                            saleType: init.saleType,
                                            clientType: init.clientType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDealerIdsField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.dealerIds, state.submissionStatus, validators_dealerIds, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                            attributionVehicleDateStart: init.attributionVehicleDateStart,
                                            dealerWithAgents: init.dealerWithAgents,
                                            dealerIds: status,
                                            saleType: init.saleType,
                                            clientType: init.clientType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSaleTypeField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.saleType, state.submissionStatus, validators_saleType, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                            attributionVehicleDateStart: init.attributionVehicleDateStart,
                                            dealerWithAgents: init.dealerWithAgents,
                                            dealerIds: init.dealerIds,
                                            saleType: status,
                                            clientType: init.clientType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateClientTypeField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.clientType, state.submissionStatus, validators_clientType, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            attributionVehicleDateEnd: init.attributionVehicleDateEnd,
                                            attributionVehicleDateStart: init.attributionVehicleDateStart,
                                            dealerWithAgents: init.dealerWithAgents,
                                            dealerIds: init.dealerIds,
                                            saleType: init.saleType,
                                            clientType: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */6 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */7 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */8 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateAttributionVehicleDateEnd: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateAttributionVehicleDateEndField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateAttributionVehicleDateStart: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateAttributionVehicleDateStartField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDealerWithAgents: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDealerWithAgentsField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateDealerIds: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateDealerIdsField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateSaleType: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateSaleTypeField */4,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateClientType: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateClientTypeField */5,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurAttributionVehicleDateEnd: (function (param) {
              Curry._1(dispatch, /* BlurAttributionVehicleDateEndField */0);
            }),
          blurAttributionVehicleDateStart: (function (param) {
              Curry._1(dispatch, /* BlurAttributionVehicleDateStartField */1);
            }),
          blurDealerWithAgents: (function (param) {
              Curry._1(dispatch, /* BlurDealerWithAgentsField */2);
            }),
          blurDealerIds: (function (param) {
              Curry._1(dispatch, /* BlurDealerIdsField */3);
            }),
          blurSaleType: (function (param) {
              Curry._1(dispatch, /* BlurSaleTypeField */4);
            }),
          blurClientType: (function (param) {
              Curry._1(dispatch, /* BlurClientTypeField */5);
            }),
          attributionVehicleDateEndResult: Formality.exposeFieldResult(state.fieldsStatuses.attributionVehicleDateEnd),
          attributionVehicleDateStartResult: Formality.exposeFieldResult(state.fieldsStatuses.attributionVehicleDateStart),
          dealerWithAgentsResult: Formality.exposeFieldResult(state.fieldsStatuses.dealerWithAgents),
          dealerIdsResult: Formality.exposeFieldResult(state.fieldsStatuses.dealerIds),
          saleTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.saleType),
          clientTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.clientType),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.attributionVehicleDateEnd || match.attributionVehicleDateStart || match.dealerWithAgents || match.dealerIds || match.saleType || match.clientType) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */6);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */7);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */8);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */8,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */9);
            })
        };
}

var FlashForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var initialState$1 = {
  clientType: "",
  saleType: /* [] */0,
  dealerIds: /* [] */0,
  dealerWithAgents: /* [] */0,
  attributionVehicleDateStart: undefined,
  attributionVehicleDateEnd: undefined
};

export {
  FlashForm ,
  initialState$1 as initialState,
}
/* react Not a pure module */
